import { combineReducers } from 'redux';
import { FETCH_AAST_ZONE, FETCH_AAST_ZONE_SUCCESS } from '../actions/zone';

const item = (state = null, action) => {
  switch (action.type) {
    case FETCH_AAST_ZONE_SUCCESS:
      return action.zone;
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_AAST_ZONE:
      return true;
    case FETCH_AAST_ZONE_SUCCESS:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  item,
  isFetching,
});

export const getIsFetching = state => state.aastPlan.zone.isFetching;

export const getZone = state => state.aastPlan.zone.item;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/plan/reducers/zone.js